import React from 'react';

export const Button = ({ label, onClick, variant, isSubmit, className, children }) => {
  const classes = () => {
    const baseClasses = ['flex rounded-lg p-3 hover:cursor-pointer', className].join(' ');
    if (variant === 'primary') {
      return [baseClasses, 'bg-pdgradient text-white'].join(' ');
    } else if(variant === 'new-primary') {
      return ['bg-pdteal text-white py-2 px-3 rounded-lg cursor-pointer hover:shadow-md transition-all duration-300'].join(' ');
    } else if (variant === 'new-outline') {
      return ['bg-white border border-pdteal text-pdteal py-2 px-3 rounded-lg cursor-pointer hover:shadow-md transition-all duration-300'].join(' ');
    }
    return baseClasses;
  };
  return (
    <button className={classes()} onClick={onClick} type={isSubmit ? 'submit' : ''}>
      {label}
      {children}
    </button>
  );
};
